// Modules
import React from "react";
import Toggle from "react-toggle";

// Styles
import "./MvToggle.sass";

// Components
import ToolTip from "../ToolTip";

type Tip = {
  label:string;
  desc:string;
};
type Props ={
  style?: React.CSSProperties;
  name: string;
  checked: boolean;
  label:string;
  labelStyle?: React.CSSProperties;
  toolTip?: [Tip];
  ariaLabel?: string
  onChange: (e: any) => void;
  id?: string
  tabIndex?: number;
}

class MvToggle extends React.Component<Props, {}> {
  constructor(props:Props) {
    super(props);
    this.toggleOnSpace = this.toggleOnSpace.bind(this)
  }

  toggleOnSpace(event: React.KeyboardEvent<HTMLElement>) {
    if (event.keyCode == 32) {
      let newEvent = {
        target: {
          name: this.props.name,
          type: "checkbox",
          checked: !this.props.checked,
        },
      };
      this.props.onChange(newEvent);
      event.preventDefault();
    }
  }

  render() {
    return (
      <div className="mv-toggle" style={this.props.style} id={this.props.id}>
        <fieldset style={{ border: 'none' }}>
          <legend style={{ display: 'none' }}>{this.props.name}</legend>
          <div className="mv-toggle-inner" style={{ position: "relative" }} tabIndex={this.props.tabIndex} onKeyDown={this.toggleOnSpace}>
            <Toggle
              icons={false}
              name={this.props.name}
              id={this.props.name}
              checked={this.props.checked}
              onChange={this.props.onChange}
              tabIndex={-1}
            />
            <label htmlFor={this.props.name} style={this.props.labelStyle}>{this.props.label}</label>
            {this.props.toolTip &&
              <div className="mv-toggle-tooltip">
                <ToolTip
                  useRefToPosition={false}
                  tabIndex={this.props.tabIndex}
                  tip={this.props.toolTip}
                  id={`mv-toggle-tooltip-${this.props.label}`}
                >
                  <span className="question-icon">{"?"}</span>
                </ToolTip>
              </div>
            }
          </div>
        </fieldset>
      </div>
    );
  }
}
export default MvToggle;
